import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.object.entries.js";
import { generatePath, matchPath } from 'react-router';
import { DEFAULT_EDIT_PLAYLIST_ROUTES } from './defaultRoutes';
function checkPlaylistPath(pathname, route, playlistId) {
  return !!matchPath(pathname, generatePath(route, {
    playlistId: playlistId
  }));
}
function getActiveTab(pathname, playlistId, routes) {
  var tabRouteMap = {
    content: 'singlePlaylistContent',
    contentPreview: 'singlePlaylistContentPreview',
    access: 'singlePlaylistAccess',
    share: 'singlePlaylistShare',
    analytics: 'singlePlaylistAnalytics',
    details: 'singlePlaylistDetails' // Note: details needs to be last as otherwise all other tabs will be matched as details
  };
  for (var _i = 0, _Object$entries = Object.entries(tabRouteMap); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      tab = _Object$entries$_i[0],
      routeKey = _Object$entries$_i[1];
    if (checkPlaylistPath(pathname, routes[routeKey], playlistId)) {
      return tab;
    }
  }
  return 'details'; // Default tab
}
export function getIsActiveTab(_ref) {
  var location = _ref.location,
    playlistId = _ref.playlistId,
    tabName = _ref.tabName,
    _ref$routes = _ref.routes,
    routes = _ref$routes === void 0 ? DEFAULT_EDIT_PLAYLIST_ROUTES : _ref$routes;
  var pathname = location.pathname;
  return getActiveTab(pathname, playlistId, routes) === tabName;
}